import { createStore, applyMiddleware, compose, Store } from "redux";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import { rootReducers } from "./combineReducer";
import { persistorConf } from "./persistorConf";

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const persistedReducer = persistReducer(persistorConf, rootReducers as any);

let reduxStore: Store | null = null;

const persist = () => {
  const store = createStore(
    persistedReducer,
    composeEnhancers(applyMiddleware(thunk)),
  );
  reduxStore = store;
  const persistor = persistStore(store);
  return { store, persistor };
};

export const getStore = (): Store | null => reduxStore;

export default persist;
